app.service('leaseLink',function(productCardConfig, modal, message, loading) {
	var config, $self, $leaselinkInstalmentItem, loadingScript = false, loadedScript = false;

	function htmlEntities(str) {
		return String(str).replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>').replace(/"/g, '”').replace(/(\r\n\t|\n|\r\t)/gm, "");
	}
	function open() {
		if (loadedScript) {
			var requestItems = [];
			var LeaseLinkClient = new LeaseLinkLib({
				apiKey: config.leaseLinkApiKey
			});
			requestItems.push(LeaseLinkClient.buildApiRequestItem(htmlEntities(config.title), config.price, 1, htmlEntities(config.category)));

			var request = LeaseLinkClient.buildApiRequest(
				document.location.host,
				"00000",
				requestItems
			);
			LeaseLinkClient.requestCalculation(request, function (data, error) {
				$leaselinkInstalmentItem.removeClass('loading');
				if (error) {
					modal.alert('Błąd wyliczenia opłaty leasingowej');
				} else {
					$('#leaselink-box .instalment-price-box').addClass('leaselink-data-loaded');
					const gross = data.FinancialOperationTypeName == 'Loan';
					$('#leaselink-rate-value').text(((gross ? data.MonthlyRateGrossValue : data.MonthlyRateNetValue).toFixed(2)).replace(/\./g,',') + ' zł');
					$('#leaselink-duration').text(data.NumberOfRates);
					$('#leaselink-entry-payment-percent').text(data.EntryPaymentPct  + ' %');
					$('#leaselink-calculation-button').attr('href', data.CalulationUrl);

				}
			});
		} else if (!loadingScript) {
			loadingScript = true;
			$.getScript("https://rep.leaselink.pl/plugin/LeaseLinkLib.min.js").done(function () {
				loadedScript = true;
				open();
			}).fail(function () {
				modal.alert('Błąd pobierania danych LeaseLink');
			});
		}
	}

	function init(){
		config = productCardConfig.getData();
		$self = $('#leaselink-box');
		$leaselinkInstalmentItem = $('.instalment-item', $self);

		if(config.showLeaseLink && !config.activeOutletCategory){
			$self.show();
			$('.js-open-leaselink',$self).on('click', function(){
				$(this).hide();
				$leaselinkInstalmentItem.addClass('loading').show();
				open();
			});
		}else{
			$self.remove();
		}
	}
	return {
		init
	}
});
